var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDefineAssets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.779,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ec6e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f0bbb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3138",
    "data-name": "Rectangle 3138",
    width: 80,
    height: 80,
    transform: "translate(16292 1488)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_define_assets",
    transform: "translate(-16292 -1488)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9141",
    "data-name": "Group 9141",
    transform: "translate(16298.99 1494.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_282",
    "data-name": "Union 282",
    d: "M55.722,64.256l-8.452-8.451a33.243,33.243,0,0,0,8.539-8.534l8.448,8.446a6.079,6.079,0,0,1,1.762,4.268,6.034,6.034,0,0,1-10.3,4.271ZM0,28.609A28.608,28.608,0,1,1,28.609,57.216,28.637,28.637,0,0,1,0,28.609Zm6.6,0A22.005,22.005,0,1,0,28.609,6.6,22.039,22.039,0,0,0,6.6,28.609Zm4.4,0a17.606,17.606,0,1,1,17.606,17.6A17.626,17.626,0,0,1,11,28.609Zm9.441-2.136a2.192,2.192,0,0,0,.023,3.1l4.818,4.731a2.18,2.18,0,0,0,3.083,0l8.384-8.251a2.194,2.194,0,1,0-3.082-3.124l-6.841,6.734-3.279-3.214a2.2,2.2,0,0,0-3.105.023Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDefineAssets);
export default __webpack_public_path__ + "static/media/ic_define_assets.40a42dc67b1384a419c08efa7a8e544d.svg";
export { ForwardRef as ReactComponent };